import type { ReportField, SortField } from "../../../../../../api/types/svTypes.ts";

export const getSortField = (field: ReportField, sorts: SortField[]) => {
  return sorts.find((s) => s.config.id === field.config.guid);
};
